import React, { FC, useState } from 'react';
import TableSimple from 'src/components/TableSimple';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import { ImportedDataType } from 'src/types/productsImport';
import { TableColumnType } from 'src/types/table';
import translate from '@translate';
import Typography from 'src/components/Typography';
import { TabType } from 'src/components/BodyTopBlock';
import Tabs from 'src/components/Tabs';
import { sizes } from 'src/themes/default';

const allColumns: TableColumnType[] = [
    {
        label: 'id',
        key: 'ID',
        defaultShow: true,
    },
    {
        label: 'sku',
        key: 'SKU',
        defaultShow: true,
    },
    {
        label: 'name',
        key: 'NAME',
        defaultShow: true,
    },
    {
        label: 'productType',
        key: 'PRODUCT_TYPE',
        defaultShow: true,
        type: 'select',
        selectOption: 'productTypeCodes',
    },
    {
        label: 'ean',
        key: 'EAN',
        defaultShow: true,
    },
    {
        label: 'expeditionMethod',
        key: 'EXP_METHOD',
        defaultShow: true,
        type: 'select',
        selectOption: 'expeditionMethodCodes',
    },
];

const tabs: TabType[] = [
    { value: 'general', label: translate('productsImport.tab.general') },
    { value: 'created', label: translate('productsImport.tab.created') },
    { value: 'updated', label: translate('productsImport.tab.updated') },
];

export interface ImportedTableProps {
    importedData: ImportedDataType;
    productTypeCodes: ConstantsCodeType[];
    expeditionMethodCodes: ConstantsCodeType[];
}

const ImportedTable: FC<ImportedTableProps> = (props) => {
    const [activeTab, setActiveTab] = useState<string>('general');

    const totalCount = {
        created: props.importedData.created?.length || 0,
        updated: props.importedData.updated?.length || 0,
    };

    if (!totalCount.created && !totalCount.updated) {
        return null;
    }

    const getRows = () => {
        switch (activeTab) {
            case 'created':
                return props.importedData.created;
            case 'updated':
                return props.importedData.updated;
            case 'general':
            default:
                return [];
        }
    };

    const rows = getRows();
    return (
        <>
            <Tabs items={tabs} selected={activeTab} onChange={setActiveTab} />
            {!rows.length && (
                <Typography gutterBottom variant="h3" sx={{ marginTop: sizes.blocks_top_MG }}>
                    {translate('productsImport.totalCountImported', totalCount)}
                </Typography>
            )}
            {!!rows.length && (
                <TableSimple
                    rowIdKey="ID"
                    rows={rows}
                    columsLabelPrefix="productsImport.table"
                    allColumns={allColumns}
                    initSort={{ column: 'ID', direction: 'DESC' }}
                    selectOptions={{
                        productTypeCodes: props.productTypeCodes,
                        expeditionMethodCodes: props.expeditionMethodCodes,
                    }}
                />
            )}
        </>
    );
};

export default ImportedTable;
